import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerAccountProfileI, CustomerProfileCreatePayloadI, RegistrationI } from '@bodyanalytics/data-models-ui';
import { ENV } from '@bodyanalytics/app-config';
import { ApiLocalRoutesEnum } from '@bodyanalytics/ui-core';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  private appConfig = inject(ENV);
  private readonly http = inject(HttpClient);

  createUser(userData: RegistrationI) {
    const url = `${this.appConfig.api}/${ApiLocalRoutesEnum.API_SUFFIX_REGISTER}`;
    return this.http.post(`${url}`, userData);
  }

  /**
   * Creates the caller's own Customer row (#1760 onboarding step). Posts to the
   * JWT-guarded self-service endpoint (`POST customer-self-service-api/profile`)
   * — the Auth0 interceptor attaches the token and the backend derives the
   * identity email from it, so the payload deliberately carries NO emailAddress
   * (a smuggled one is rejected with 400 by the backend whitelist).
   * Idempotent server-side: if the row already exists it is returned unchanged.
   */
  createProfile(profile: CustomerProfileCreatePayloadI): Observable<CustomerAccountProfileI> {
    const url = `${this.appConfig.api}/${ApiLocalRoutesEnum.API_SUFFIX_CUSTOMER_SELF_PROFILE}`;
    return this.http.post<CustomerAccountProfileI>(url, profile);
  }
}
